<form [formGroup]="formGroup" id="step5Form">
  <div class="step5-form-container">
    <div class="row">
      <div
        *ngIf="controls.noFamilyMembersInPoland as noFamilyMembersInPoland"
        class="standard-form-field radio-form-field noFamilyMembersInPoland-field required-field">
        <label
          id="noFamilyMembersInPolandLabel"
          [class.invalid]="noFamilyMembersInPoland.touched && noFamilyMembersInPoland.invalid">
          {{ 'PERSONAL_DATA_FORM.HAS-FAMILY-MEMBERS-IN-POLAND-LONG-RESI.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="noFamilyMembersInPoland"
          aria-labelledby="noFamilyMembersInPolandLabel"
          formControlName="noFamilyMembersInPoland"
          (keydown)="firstInputKeydown($event)"
          (keydown.Tab)="controls.noFamilyMembersInPoland.value === true ? emitLastFieldTabPressed($event) : undefined"
          [required]="true"
          [attr.aria-invalid]="
            controls.noFamilyMembersInPoland.touched && controls.noFamilyMembersInPoland.invalid ? 'true' : null
          ">
          <!-- Inverted values because of label we're using -->
          <mat-radio-button [value]="false" id="applicantNoFamilyMembersInPoland-0">
            {{ 'COMMON.GENERAL.YES' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="true" id="applicantNoFamilyMembersInPoland-1">
            {{ 'COMMON.GENERAL.NO' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div *ngIf="controls.noFamilyMembersInPoland.value === false" class="row" aria-live="polite">
      <app-family-members-form-long-resi
        [fieldControl]="controls.familyMembersInPoland"
        (lastFieldTabPressed)="emitLastFieldTabPressed($event)">
      </app-family-members-form-long-resi>
    </div>
  </div>
</form>
